import {
    GridActionsCellItemProps,
    GridColDef,
    GridRowParams,
    GridValueFormatterParams,
    GridValueGetterParams,
} from '@mui/x-data-grid-premium';
import { ReactElement, useMemo } from 'react';
import { Cell } from '../../components';
import { columnWidths } from '../../consts';
import dayjs from 'dayjs';
import { DEFAULT_DATE_FORMAT } from '@thought-river/ui-components';

const NON_FILTERABLE_COLUMNS = ['progress'];

export const useGetColumns = (
    columns: any[],
    actionsColumnActions: (
        params: GridRowParams
    ) => ReactElement<GridActionsCellItemProps>[]
): GridColDef[] => {
    const memoizedColumns = useMemo(() => {
        const columnDefs = columns.map<GridColDef>((column: any) => ({
            ...column,
            minWidth: columnWidths[column.field] || 150,
            flex: 1,
            renderCell: Cell,
            valueGetter: (params: GridValueGetterParams) => {
                //TODO: ask backend if we could combine version status with processing status
                if (
                    column.field === 'version_status' &&
                    params.row.processing_status !== 'processed'
                ) {
                    return params.row.processing_status;
                }

                if (column.field === 'progress') {
                    const resolvedIssues = params.row.issues_resolved;
                    const totalIssues = params.row.issues_total;
                    const resolvedRatio =
                        totalIssues === 0
                            ? 100
                            : (100 / totalIssues) * resolvedIssues;
                    return resolvedRatio;
                }

                if (column.field === 'version') {
                    return params.row.version.number;
                }

                if (column.type === 'date' || column.type === 'dateTime') {
                    return dayjs(params.value).toDate();
                }

                return params.value;
            },
            valueFormatter: (params: GridValueFormatterParams) => {
                if (column.type === 'date' || column.type === 'dateTime') {
                    return dayjs(params.value).format(DEFAULT_DATE_FORMAT);
                }
            },
            groupable: false,
            filterable: !NON_FILTERABLE_COLUMNS.includes(column.field),
        }));

        //actions column
        columnDefs.push({
            field: 'actions',
            headerName: 'Contract actions',
            renderHeader: () => '',
            type: 'actions',
            minWidth: 50,
            maxWidth: 50,
            getActions: actionsColumnActions,
            hideable: false,
        });

        return columnDefs;
    }, [columns, actionsColumnActions]);

    return memoizedColumns;
};
